// stores/useChatSidebar.ts
import { ref, watch } from 'vue'

const WIDTH_KEY = 'ChatSidebar:width'
const WIDTH_DEFAULT = 384 // w-96
const WIDTH_MIN = 320
const WIDTH_MAX = 900

// Läs initialt läge från localStorage (default false)
const initial = (() => {
    try {
        const v = localStorage.getItem('ChatSidebar:isOpen')
        return v === '1'
    } catch {
        return false
    }
})()

const isChatOpen = ref<boolean>(initial)

const initialWidth = (() => {
    try {
        const v = localStorage.getItem(WIDTH_KEY)
        if (v != null) {
            const n = parseInt(v, 10)
            if (!Number.isNaN(n) && n >= WIDTH_MIN && n <= WIDTH_MAX) return n
        }
    } catch {}
    return WIDTH_DEFAULT
})()

const chatDrawerWidth = ref<number>(initialWidth)

// Persistera vid ändring
watch(isChatOpen, (v) => {
    try {
        localStorage.setItem('ChatSidebar:isOpen', v ? '1' : '0')
    } catch {}
}, { immediate: true })

watch(chatDrawerWidth, (v) => {
    try {
        localStorage.setItem(WIDTH_KEY, String(Math.min(WIDTH_MAX, Math.max(WIDTH_MIN, v))))
    } catch {}
}, { immediate: true })

export function useChatSidebar() {
    const open  = () => (isChatOpen.value = true)
    const close = () => (isChatOpen.value = false)
    const toggle = () => (isChatOpen.value = !isChatOpen.value)
    return {
        isChatOpen,
        open,
        close,
        toggle,
        chatDrawerWidth,
        chatDrawerWidthMin: WIDTH_MIN,
        chatDrawerWidthMax: WIDTH_MAX,
    }
}
